module.exports = __webpack_public_path__ + "static/media/KMH_4895.9810dfb1.jpg";